import React from 'react';

import { ScreenGo } from '@gogame/screens';

import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeList,
  AttributeItem,
} from 'scenes/Gallery/components/AttributeList';
import { PreviewWithScrubber } from 'scenes/Gallery/components/File';
import {
  VIDEO_LENGTH,
  THUMBNAIL_URL,
  SCRUBBING_URLS,
} from 'scenes/Gallery/components/File/constants';

const PreviewColumn = ({ row }) => {
  const {
    [CREATIVE.ID]: id,
    [CREATIVE.FILE]: {
      [THUMBNAIL_URL]: fileThumbnailURL,
      [VIDEO_LENGTH]: fileVideoLength,
      [SCRUBBING_URLS]: scrubbingUrls,
    },
    [CREATIVE.IS_THUMBNAIL_GENERATING]: isThumbnailGenerating,
  } = row;

  return (
    <ScreenGo to={`${id}`} data-cy={'Creative Details'}>
      <PreviewWithScrubber
        src={fileThumbnailURL}
        thumbnail={isThumbnailGenerating}
        width={109}
        height={64}
        withOverlay={false}
        scrubbingUrls={scrubbingUrls}
        attributes={
          <AttributeList
            justifyContent={'space-between'}
            direction={'row-reverse'}
            color={'common.white'}
            spacing={0.5}
            p={0.5}
          >
            {fileVideoLength ? (
              <AttributeItem
                valueParser={'fileVideoLength'}
                value={fileVideoLength}
              />
            ) : null}
          </AttributeList>
        }
      />
    </ScreenGo>
  );
};
export default PreviewColumn;
